import axios from 'axios';

const login = async (credentials) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/api/login`,
    credentials
  );

  // el backend responde: { status_code, data: { token, user, menus }, message }
  const { token, user, menus } = response.data.data;

  return { token, user, menus };
};

const logout = async () => {
  await axios.get(`${process.env.REACT_APP_API_URL}/auth/api/logout`);
};

const changePassword = async (passwordData) => {
  const token = localStorage.getItem('access_token');
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/api/change-password`,
    passwordData,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const register = async (registrationData) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/api/register`,
    registrationData
  );
  return response.data;
};

const authService = {
  login,
  logout,
  changePassword,
  register,
};

export default authService;